//dependencias
import React, { Component } from 'react';

//componentes
import PermisoNotasDAction from './permisoNotaD'

class Index extends Component {

    render(){
        return(
            <div>
                <PermisoNotasDAction />
            </div>
        );
    }

}
export default Index;